import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Link, useLocation } from "react-router-dom";
import Icons from "./Icons.js";
import { IoCheckmarkCircle } from "react-icons/io5";
import { FaCheckSquare } from "react-icons/fa";


const Sidebar = (props) => {
  const location = useLocation();
  const { profile } = props;
  const { role } = profile;

  const [collapsed, setCollapsed] = useState(true);

  const getSvgProps = (path) => {
    if (path === "/risk") {
      return location.pathname === path
        ? { fill: "#3b3b3b", what: path }
        : { fill: "#c3cfd1", what: path };
    } else {
      return location.pathname.startsWith(path)
        ? { fill: "#3b3b3b", what: path }
        : { fill: "#c3cfd1", what: path };
    }
  };

  useEffect(() => {
    setCollapsed(true);
  }, []);

  return (
    <div
      className={`flex ${
        collapsed ? "w-16" : "w-64"
      } h-screen transition-width duration-300 bg-[#F0F0F0]`}
    >
      <div className="flex flex-col w-full">
        <nav className="flex flex-col mt-0">
          <Link
            to="/units"
            className={`flex flex-col items-center p-2 text-[#464646] hover:bg-white h-16 ${
              collapsed ? "justify-center" : ""
            } text-mm ${
              location.pathname.startsWith("/units")
                ? "border-l-4 border-[#3b3b3b]"
                : "border-l-4 border-transparent"
            }`}
          >
            <Icons
              alt="Units"
              {...getSvgProps("/units")}
              className={`w-6 h-6 p-2`}
            />
            <span
              className={`text-[10px] mt-1 text-center ${
                location.pathname.startsWith("/units")
                  ? "text-[#3b3b3b]"
                  : "text-[#464646]"
              }`}
            >
              Units
            </span>
          </Link>

        {/* <Link
            to="/compliance"
            className={`flex flex-col items-center p-2 text-[#464646] hover:bg-white h-16 ${
              collapsed ? "justify-center" : ""
            } text-mm ${
              location.pathname.startsWith("/compliance")
                ? "border-l-4 border-[#3b3b3b]"
                : "border-l-4 border-transparent"
            }`}
          >
              <FaCheckSquare
                size={40} className={`p-1 ${location.pathname.startsWith("/compliance")
                    ? "text-[#3b3b3b]"
                    : "text-[#c3cfd1]"
                  }`} />
              <span
                className={`text-[10px] mt-1 text-center ${
                  location.pathname.startsWith("/compliance")
                    ? "text-[#3b3b3b] font-bold"
                    : "text-[#464646]"
                }`}
              >
                Compliance
              </span>
          </Link>  */}

          {/* <Link
            to="/IT"
            className={`flex flex-col items-center p-2 text-[#464646] hover:bg-white h-16 ${
              collapsed ? "justify-center" : ""
            } text-mm ${
              location.pathname.startsWith("/IT")
                ? "border-l-4 border-[#3b3b3b]"
                : "border-l-4 border-transparent"
            }`}
          >
              <Icons
                alt="IT"
                {...getSvgProps("/IT")}
                className={`w-6 h-6 p-2`}
              />
            <span
              className={`text-[10px] mt-1 text-center ${
                location.pathname.startsWith("/IT")
                  ? "text-[#3b3b3b]"
                  : "text-[#464646]"
              }`}
            >
              IT
            </span>
          </Link> */}

          {role === "Admin" || role === "Auditor" ? (
            <Link
              to="/dashboards"
              className={`flex flex-col items-center p-2 text-[#464646] hover:bg-white h-16 ${
                collapsed ? "justify-center" : ""
              } text-mm ${
                location.pathname.startsWith("/dashboards")
                  ? "border-l-4 border-[#3b3b3b]"
                  : "border-l-4 border-transparent"
              }`}
            >
              <Icons
                alt="Dashboard"
                {...getSvgProps("/dashboards")}
                className={`w-6 h-6 p-2`}
              />
              <span
                className={`text-[10px] mt-1 text-center ${
                  location.pathname.startsWith("/dashboards")
                    ? "text-[#3b3b3b] font-bold"
                    : "text-[#464646]"
                }`}
              >
                Dashboard
              </span>
            </Link>
          ) : null}

          <Link
            to="/risk"
            className={`flex flex-col items-center p-2 text-[#464646] hover:bg-white h-16 ${
              collapsed ? "justify-center" : ""
            } text-mm ${
              location.pathname === "/risk"
                ? "border-l-4 border-[#3b3b3b]"
                : "border-l-4 border-transparent"
            }`}
          >
            <Icons
              alt="Risk"
              {...getSvgProps("/risk")}
              className={`w-6 h-6 p-2`}
            />
            <span
              className={`text-[10px] mt-1 text-center ${
                location.pathname === "/risk"
                  ? "text-[#3b3b3b] font-bold"
                  : "text-[#464646]"
              }`}
            >
              Risk
            </span>
          </Link>

          {role === "Admin" && (
            <Link
              to="/controls"
              className={`flex flex-col items-center p-2 text-[#464646] hover:bg-white h-16 ${
                collapsed ? "justify-center" : ""
              } text-mm ${
                location.pathname.startsWith("/controls")
                  ? "border-l-4 border-[#3b3b3b]"
                  : "border-l-4 border-transparent"
                }`}
            >
              <IoCheckmarkCircle
                size={40} className={`p-1 ${location.pathname.startsWith("/controls")
                    ? "text-[#3b3b3b]"
                    : "text-[#c3cfd1]"
                  }`} />
              <span
                className={`text-[10px] mt-1 text-center ${
                  location.pathname.startsWith("/controls")
                    ? "text-[#3b3b3b] font-bold"
                    : "text-[#464646]"
                }`}
              >
                Controls
              </span>
            </Link>
          )}

          <Link
            to="/actions"
            className={`flex flex-col items-center p-2 text-[#464646] hover:bg-white h-16 ${
              collapsed ? "justify-center" : ""
            } text-mm ${
              location.pathname.startsWith("/actions")
                ? "border-l-4 border-[#3b3b3b]"
                : "border-l-4 border-transparent"
            }`}
          >
            <Icons
              alt="Actions"
              {...getSvgProps("/actions")}
              className={`w-6 h-6`}
            />
            <span
              className={`text-[10px] mt-1 text-center ${
                location.pathname.startsWith("/actions")
                  ? "text-[#3b3b3b] font-bold"
                  : "text-[#464646]"
              }`}
            >
              Actions
            </span>
          </Link>

      {/* {role === "Admin" && (
            <Link
              to="/standards"
              className={`flex flex-col items-center p-2 text-[#464646] hover:bg-white h-16 ${
                collapsed ? "justify-center" : ""
              } text-mm ${
                location.pathname.startsWith("/standards")
                  ? "border-l-4 border-[#3b3b3b]"
                  : "border-l-4 border-transparent"
              }`}
            >
              <Icons
                alt="AI"
                {...getSvgProps("/ai")}
                className={`w-6 h-6`}
              />
              <span
                className={`text-[10px] mt-1 text-center ${
                  location.pathname.startsWith("/standards")
                    ? "text-[#3b3b3b] font-bold"
                    : "text-[#464646]"
                }`}
              >
                Standards
              </span>
            </Link>
          )} */}

          



          {/* <Link
            to="/ai"
            className={`flex flex-col items-center p-2 text-[#464646] hover:bg-white h-16 ${
              collapsed ? "justify-center" : ""
            } text-mm ${
              location.pathname.startsWith("/ai")
                ? "border-l-4 border-[#3b3b3b]"
                : "border-l-4 border-transparent"
            }`}
          >
            <Icons
              alt="AI"
              {...getSvgProps("/ai")}
              className={`w-6 h-6`}
            />
            <span
              className={`text-[10px] mt-1 text-center ${
                location.pathname.startsWith("/ai")
                  ? "text-[#3b3b3b] font-bold"
                  : "text-[#464646]"
              }`}
            >
              Rabo
            </span>
          </Link> */}

          {role === "Admin" && (
            <Link
              to="/admin"
              className={`flex flex-col items-center p-2 text-[#464646] hover:bg-white h-16 ${
                collapsed ? "justify-center" : ""
              } text-mm ${
                location.pathname.startsWith("/admin")
                  ? "border-l-4 border-[#3b3b3b]"
                  : "border-l-4 border-transparent"
              }`}
            >
              <Icons
                alt="Admin"
                {...getSvgProps("/admin")}
                className={`w-6 h-6`}
              />
              <span
                className={`text-[10px] mt-1 text-center ${
                  location.pathname.startsWith("/admin")
                    ? "text-[#3b3b3b] font-bold"
                    : "text-[#464646]"
                }`}
              >
                Admin
              </span>
            </Link>
          )}

            {/* {role === "Admin" && <Link to="/risk_levels" className={`flex flex-col items-center p-2 text[#464646] hover:bg-[#467587] h-16  ${collapsed ? 'justify-center' : ''} text-mm active:bg-[#3b3b3b] ${location.pathname.startsWith("/risk_levels") ? 'bg-[#3b3b3b] bg-opacity-20' : 'active:bg-opacity-20'}`}>
                        <Icons alt="Risk Levels" {...getSvgProps("/risk_levels")} className={`w-6 h-6`} />
                        <span className={`text-[10px] mt-1 text-center ${location.pathname.startsWith("/risk_levels") ? 'text-[#3b3b3b] font-bold' : 'text[#464646]'} `}>Levels</span>
            </Link>} */}


        </nav>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    profile: state.profile.profile,
  };
};

export default compose(connect(mapStateToProps))(Sidebar);